/* tslint:disable */
/* eslint-disable */
export enum MedicalFormRecipient {
  Hospital = 'HOSPITAL',
  Patient = 'PATIENT'
}
